import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=750e06ee&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=750e06ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e06ee",
  null
  
)

export default component.exports